var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedD(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.3851 9.11875L10.8812 1.61406C10.647 1.38125 10.3302 1.25057 9.99999 1.25057C9.66976 1.25057 9.35294 1.38125 9.11874 1.61406L1.61874 9.11875C1.38593 9.35295 1.25525 9.66977 1.25525 10C1.25525 10.3302 1.38593 10.647 1.61874 10.8813L9.12265 18.3859C9.35685 18.6188 9.67367 18.7494 10.0039 18.7494C10.3341 18.7494 10.6509 18.6188 10.8851 18.3859L18.3891 10.8813C18.6219 10.647 18.7525 10.3302 18.7525 10C18.7525 9.66977 18.6219 9.35295 18.3891 9.11875H18.3851ZM9.99999 17.5L2.49999 10L9.99999 2.5L17.5 10L9.99999 17.5Z",
    fill: "#FF4545"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedD);
export default __webpack_public_path__ + "static/media/redD.3bb72cec31f850c525403a5ffc126e2e.svg";
export { ForwardRef as ReactComponent };